import { Switch } from "@/components/ui/switch";
import type { ReactNode } from "react";

interface Props {
  title: string;
  description: string;
  icon?: ReactNode;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
}

const FeatureToggleCard = ({
  title,
  description,
  icon,
  checked,
  onCheckedChange,
}: Props) => {
  return (
    <div className="flex items-start justify-between rounded-xl border bg-card p-5 transition-colors hover:border-primary/40">
      <div className="flex gap-4">
        {icon && (
          <div className="mt-1 flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10">
            {icon}
          </div>
        )}

        <div>
          <h4 className="font-medium">{title}</h4>

          <p className="mt-1 text-sm text-muted-foreground">{description}</p>
        </div>
      </div>

      <Switch checked={checked} onCheckedChange={onCheckedChange} />
    </div>
  );
};

export default FeatureToggleCard;
